import { VoidedRaceBanner } from './VoidedRaceBanner';

export default VoidedRaceBanner;
